import { Box, CircularProgress } from "@mui/material";
import { useState } from "react";
import Cropper, { Area } from "react-easy-crop";

type Props = {
    imageDataUrl?: string;
    onCropComplete: (pixels: Area) => void;
};

export default function PhotoCropper({ imageDataUrl, onCropComplete }: Props) {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);

    return (
        <Box
            sx={{
                aspectRatio: 1,
                width: 1,
                position: "relative",
            }}
        >
            {!imageDataUrl && <CircularProgress />}
            <Cropper
                image={imageDataUrl}
                crop={crop}
                zoom={zoom}
                aspect={1}
                cropShape="round"
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={(_: Area, pixels: Area) => onCropComplete(pixels)}
            />
        </Box>
    );
}
